import type { ApiV1DashboardSummaryGet200ResponseSummary } from './apiV1DashboardSummaryGet200ResponseSummary';

export interface ApiV1DashboardSummaryGet200Response {
  message?: string;
  success: boolean;
  summary?: ApiV1DashboardSummaryGet200ResponseSummary;
}
